import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Amenagement } from 'src/app/shared/models/amenagement';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AmenagementModalAjoutComponent } from '../modal/amenagement-modal-ajout/amenagement-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { AmenagementModalDetailComponent } from '../modal/amenagement-modal-detail/amenagement-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-amenagement',
	templateUrl: './list-amenagement.component.html',
	styleUrls: ['./list-amenagement.component.scss']
})
export class ListAmenagementComponent implements OnInit {
	amenagement: Amenagement[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	amenagementCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editAmenagementModalRef: BsModalRef;
	addAmenagementModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getAmenagement();
		this.isAddable = true;
	}

	getAmenagement(): void {
		this.isListingLoading = true;
		this.facade.amenagementService.getAllAmenagement().subscribe({
			next: (val) => {
				this.amenagement = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.amenagement.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.amenagement = [];
			}
		});
	}

	selectAmenagement(amenagement: Amenagement): void {
		const link = ['/amenagement', amenagement.id];
		this.router.navigate(link);
	}

	importAmenagement(event: any): void {
		this.amenagementCsvFile = event.target.files[0];

		this.facade.amenagementService
			.importAmenagement(this.amenagementCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} amenagement ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getAmenagement();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addAmenagementModalRef = this.modalService.show(
			AmenagementModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addAmenagementModalRef.onHide.subscribe((reason: string | any) => {
			this.getAmenagement();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(amenagement: Amenagement) {
		const initialState = {
			amenagement: amenagement
		};
		this.editAmenagementModalRef = this.modalService.show(
			AmenagementModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editAmenagementModalRef.onHide.subscribe((reason: string | any) => {
			this.getAmenagement();
		});
	}
}
